const configsStaging = 'https://beta-sb-app-configs-vlwut6qbsq-ew.a.run.app';
const configsLive = 'https://sb-app-configs-jtdpxp3bfa-ew.a.run.app';
export const apiBase = () => {
	return [true, 'true'].includes(process['env'].PROD_ENV) ? configsLive : configsStaging;
	// local dev purposes
	// return configsStaging;
};

/**
 * @param {any} userid
 * @param {any} configType
 * @param {any} configLabel
 * @param {any} fname
 * @param {any} client
 * @param {any} source
 */
export async function getConfig(userid, client, configType, configLabel, fname, source) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	let url = `${apiBase()}/v2/configs/${configType}/customer/${client}${userToken}`;

	if (configLabel) {
		url += `&config_label=${configLabel}`;
	}
	if (fname) {
		url += `&fname=${fname}`;
	}
	if (source) {
		url += `&source_config_type=${source}`;
	}
	const res = await fetch(url);
	return await res.json();
}

/**
 * @param {any} userid
 * @param {any} configType
 * @param {any} configLabel
 * @param {any} client
 * @param {any} config
 */
export async function saveConfig(userid, client, configType, configLabel, config) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	let url = `${apiBase()}/v2/configs/${configType}/customer/${client}${userToken}`;
	if (configLabel) {
		url = url + `&config_label=${configLabel}`;
	}
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			Accept: 'application/json, text/plain, */*',
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(config)
	});
	if (res.ok) {
		return await res.json();
	}
	return { detail: 'oops we broke something' };
}

/**
 * @param {any} userid
 * @param {any} client
 */
export async function listConfigs(userid, client) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	const url = apiBase() + '/v2/config-types/' + `${client}${userToken}`;
	const res = await fetch(url);
	return res.json();
}
/**
 * @param {any} userid
 */
export async function listClients(userid) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	const url = apiBase() + '/v2/configs/client/list' + `${userToken}`;
	const res = await fetch(url);
	return res.json();
}

/**
 * @param {any} userid
 * @param {any} client
 * @param {any} configType
 * @param {any} configLabel
 */
export async function getConfigHistory(userid, client, configType, configLabel) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	let url = `${apiBase()}/v2/configs/${configType}/list/${client}${userToken}`;

	if (configLabel) {
		url = url + `&config_label=${configLabel}`;
	}
	const res = await fetch(url);
	return await res.json();
}

/**
 * @param {any} userid
 * @param {any} configType
 * @param {any} configLabel
 * @param {any} client
 * @param {any} source
 */
export async function deleteConfig(userid, client, configType, configLabel, source) {
	const userToken = `?token=${userid}`;
	if (userToken == '?token=undefined') return;
	let url = `${apiBase()}/v2/configs/${configType}/customer/${client}${userToken}`;
	if (configLabel) {
		url = url + `&config_label=${configLabel}`;
	}
	if (source) {
		url += `&source_config_type=${source}`;
	}
	const res = await fetch(url, {
		method: 'DELETE'
	});

	if (res.ok) {
		return await res.json();
	}

	return { detail: 'oops we broke something' };
}
